module.exports = __webpack_public_path__ + "static/media/WWII-Tunnel-Growing-Underground.19de6608.jpg";